import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        { staticClass: "mt-2 card-filters" },
        [
          _c(
            VCardTitle,
            {
              staticClass: "pointer",
              on: {
                click: function ($event) {
                  _vm.collapse_filter = !_vm.collapse_filter
                },
              },
            },
            [
              _vm._v(_vm._s(_vm.$t("filtros.search_filters"))),
              _c(VSpacer),
              !_vm.collapse_filter
                ? _c(
                    VBtn,
                    { attrs: { icon: "" } },
                    [_c(VIcon, [_vm._v("mdi-chevron-down")])],
                    1
                  )
                : _c(
                    VBtn,
                    { attrs: { icon: "" } },
                    [_c(VIcon, [_vm._v("mdi-chevron-up")])],
                    1
                  ),
            ],
            1
          ),
          _vm.collapse_filter
            ? _c(
                "div",
                [
                  !_vm.isEmptyTable
                    ? _c("search-in-table-new", {
                        attrs: {
                          placeholder: "Search in your own tables ...",
                          withConditions: false,
                          defaultDomain: _vm.defaultDomain,
                        },
                        on: { submit: _vm.sendToSearch },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(
            "div",
            { staticClass: "text-right pa-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.openAllTempOwner()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons md-16" }, [
                    _vm._v("done_all"),
                  ]),
                  _vm._v("Assign all tables to temporal Data operator"),
                ]
              ),
            ],
            1
          ),
          _c("b-table", {
            ref: "my-tables-operator",
            staticClass: "text-center",
            style: { "font-size": "11px" },
            attrs: {
              responsive: "",
              hover: "",
              items: _vm.queryResponse.tables,
              "sort-by.sync": "columns_change",
              "sort-desc.sync": "true",
              fields: _vm.getTableFields(),
              filter: _vm.filter,
              filterIncludedFields: _vm.filterOn,
              "sticky-header": true,
              "show-empty": "",
            },
            scopedSlots: _vm._u([
              {
                key: "empty",
                fn: function (scope) {
                  return [_vm._v(_vm._s(_vm.messageEmptyList))]
                },
              },
              {
                key: "cell(tableReference.tableId)",
                fn: function (row) {
                  return [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", [
                        _c(
                          "a",
                          {
                            staticClass: "table-name",
                            on: {
                              click: function ($event) {
                                return _vm.openEditTpl(
                                  row.item,
                                  _vm.MODAL_NAME_METADATA_VIEW
                                )
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(row.item.tableReference.tableId)),
                            ]),
                          ]
                        ),
                      ]),
                      _c(
                        "a",
                        {
                          staticClass: "compose-name",
                          attrs: { title: row.item.id },
                          on: {
                            click: function ($event) {
                              return _vm.openEditTpl(
                                row.item,
                                _vm.MODAL_NAME_METADATA_VIEW
                              )
                            },
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("joinTableReference")(
                                  row.item.tableReference
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(creationTime)",
                fn: function (row) {
                  return [
                    _c("span", { staticClass: "date-format" }, [
                      _vm._v(
                        _vm._s(_vm._f("formatDate")(row.item.creationTime))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "cell(numRows)",
                fn: function (row) {
                  return [
                    _c("span", { staticClass: "date-format" }, [
                      _vm._v(_vm._s(_vm._f("formatNumber")(row.item.numRows))),
                    ]),
                  ]
                },
              },
              {
                key: "cell(schema.fields.length)",
                fn: function (row) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.bottom",
                            value: row.item.columns_change
                              ? "One or more columns were changed or added!"
                              : "",
                            expression:
                              "row.item.columns_change ? 'One or more columns were changed or added!':''",
                            modifiers: { hover: true, bottom: true },
                          },
                        ],
                        class: row.item.columns_change
                          ? "text-danger font-weight-bold"
                          : "",
                      },
                      [_vm._v(_vm._s(row.item.schema.fields.length || 0))]
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Update Metadata",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openEditTpl(
                              row.item,
                              _vm.MODAL_NAME_METADATA
                            )
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "pencil-fill" } })],
                      1
                    ),
                    !_vm.approvalFlow &&
                    row.item.defaultFields.operator.stringValue ==
                      _vm.currentEmail
                      ? _c(
                          "b-button",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              size: "sm",
                              variant: "outline-primary",
                              title: "Sync Table",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.asyncTableWithSchema(row)
                              },
                            },
                          },
                          [
                            _c("b-icon", {
                              attrs: { icon: "arrow-clockwise" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "BigQuery View",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.generateViewUrl(row.item)
                          },
                        },
                      },
                      [_c("b-icon-eye")],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Manage Access",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openModal(
                              row.item.tableReference,
                              _vm.MODAL_LIST_ACCESS
                            )
                          },
                        },
                      },
                      [_c("b-icon-lock-fill")],
                      1
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          id: "popover-more-actions-" + row.item.id,
                          size: "sm",
                          variant: "outline-primary",
                          title: "More Actions",
                        },
                      },
                      [_c("b-icon-plus")],
                      1
                    ),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          target: "popover-more-actions-" + row.item.id,
                          triggers: "hover",
                          placement: "bottom",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "close",
                                      attrs: { "aria-label": "Close" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "d-inline-block",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [_vm._v("×")]
                                      ),
                                    ]
                                  ),
                                  _c("span", [_vm._v("More Actions")]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        !_vm.approvalFlow &&
                        row.item.defaultFields.env.enumValue.displayName ===
                          "prod" &&
                        row.item.defaultFields.operator.stringValue ==
                          _vm.currentEmail
                          ? _c(
                              "b-button",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                  title: "Set Temporal data operator",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openTempOwner(row.item)
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "people-fill" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.approvalFlow &&
                        row.item.defaultFields.env.enumValue.displayName ===
                          "prod" &&
                        row.item.defaultFields.operator.stringValue ==
                          _vm.currentEmail
                          ? _c(
                              "b-button",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-primary",
                                  title: "Profiling",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.openModal(
                                      row.item.tableReference,
                                      _vm.MODAL_PROFILING_RULES
                                    )
                                  },
                                },
                              },
                              [_c("b-icon-bar-chart-steps")],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.approvalFlow
        ? _c(
            "div",
            { staticClass: "pagination" },
            [
              _vm.queryResponse
                ? _c(
                    "b-button-group",
                    [
                      _vm.paginationObj.offset > 0
                        ? _c(
                            "b-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goPaginate("FIRST")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "mdi mdi-page-first" }),
                              _vm._v("First"),
                            ]
                          )
                        : _vm._e(),
                      _vm.paginationObj.previous !== null
                        ? _c(
                            "b-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goPaginate("PREV")
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "mdi mdi-page-first" }),
                              _vm._v("Prev"),
                            ]
                          )
                        : _vm._e(),
                      _vm.paginationObj.next !== null
                        ? _c(
                            "b-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.goPaginate("NEXT")
                                },
                              },
                            },
                            [
                              _vm._v("Next"),
                              _c("i", { staticClass: "mdi mdi-arrow-right" }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.approvalFlow
        ? _c("pagination-searching", {
            attrs: {
              queryObject: _vm.queryResponse,
              reloadMethod: _vm.reloadList,
              isNewQuery: _vm.isNewQuery,
            },
          })
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: { size: "xl", "hide-footer": "", id: _vm.MODAL_NAME_METADATA },
        },
        [
          _c("template", { slot: "modal-title" }, [_vm._v("Change metadata")]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-metadata", {
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.CHANGE_REQUEST,
                },
                on: {
                  submit: _vm.saveTags,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_METADATA)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            id: _vm.MODAL_NAME_METADATA_VIEW,
            "hide-footer": "",
          },
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Metadata Table Detail"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-metadata", {
                attrs: {
                  tplToWork: _vm.tplToUpdate,
                  isChangeRequest: _vm.TYPE_CHANGE_METADA.VIEWER_ONLY,
                },
                on: {
                  submit: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_METADATA_VIEW)
                  },
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_METADATA_VIEW)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: { tplToWork: _vm.tplToUpdate },
                on: {
                  submit: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_ALL_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign all tables to temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: { isForAllOwners: true },
                on: {
                  submit: _vm.assignAllOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_ALL_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            id: _vm.MODAL_NAME_PROFILING_VIEW,
            "hide-footer": "",
            size: "xl",
          },
        },
        [
          _c("template", { slot: "modal-title" }, [_vm._v("DATA PROFILING")]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("history-item", {
                attrs: { item: _vm.item, readonly: true },
                on: {
                  closeModal: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_PROFILING_VIEW)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: _vm.MODAL_CONFIRM_EXECUTE_PROFILING,
          attrs: {
            id: _vm.MODAL_CONFIRM_EXECUTE_PROFILING,
            size: "sm",
            "hide-footer": "",
          },
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("EXECUTE PROFILING"),
          ]),
          _c("profiling-execute-item", {
            attrs: { item: _vm.tableExecute },
            on: { closeExecuteItem: _vm.closeExecuteItem },
          }),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: _vm.MODAL_PROFILING_RULES,
          attrs: {
            id: _vm.MODAL_PROFILING_RULES,
            size: "sm",
            "hide-footer": "",
          },
        },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("CHOOSE PROFILING RULE"),
          ]),
          _c("modal-profiling-rules", {
            attrs: { tableReference: _vm.tableReference },
            on: { viewDetail: _vm.viewDetail },
          }),
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: _vm.MODAL_LIST_ACCESS,
          attrs: { id: _vm.MODAL_LIST_ACCESS, size: "sm", "hide-footer": "" },
        },
        [
          _c("template", { slot: "modal-title" }, [_vm._v("ACCESS TABLE")]),
          _c("modal-access", { attrs: { tableReference: _vm.tableReference } }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }